var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamahangLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_6",
    "data-name": "Custom Size \\u2013 6",
    clipPath: "url(#clip-Custom_Size_6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-1635.335 -4097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1151.408,320.174a63.371,63.371,0,0,1-63.135,63.135,94.336,94.336,0,0,0-63.136,24.227V320.174a63.4,63.4,0,0,1,63.136-63.135h63.135v63.135Z",
    transform: "translate(922.198 4088.96)",
    fill: "#f6c700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1040.608,383.309H977.472V320.174a63.4,63.4,0,0,1,63.136-63.135h63.135v63.135a63.371,63.371,0,0,1-63.135,63.135Z",
    transform: "translate(1220.413 4088.96)",
    fill: "#f6c700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1088.273,317.109h63.135v63.135a63.381,63.381,0,0,1-63.135,63.13h-63.136v-63.13a63.371,63.371,0,0,1,63.136-63.135Z",
    transform: "translate(922.198 4342.223)",
    fill: "#f6c700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1291.157,432.963H1040.608A94.367,94.367,0,0,0,977.472,457.2V369.832a63.371,63.371,0,0,1,63.136-63.136h250.549a94.359,94.359,0,0,0,63.135-24.233v87.368a63.362,63.362,0,0,1-63.135,63.131Z",
    transform: "translate(969.864 4189.807)",
    fill: "#f6c700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M1635.394,1291.875v-63.13q0-2.141.143-4.248h-.2v-63.135a63.37,63.37,0,0,1,63.135-63.135A94.34,94.34,0,0,0,1761.607,1074v87.362q0,2.141-.143,4.248h.2v63.135a63.381,63.381,0,0,1-63.135,63.13Z",
    transform: "translate(562.55 3555.39)",
    fill: "#f6c700",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamahangLogo);
export default __webpack_public_path__ + "static/media/hamahangLogo.c7997af0759f768087bcff807b6e04e2.svg";
export { ForwardRef as ReactComponent };